import { render, staticRenderFns } from "./Assigning.vue?vue&type=template&id=6ee360c9"
import script from "./Assigning.vue?vue&type=script&lang=js"
export * from "./Assigning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports